export default __webpack_public_path__ + "static/media/190629_190332_IMG_5997.327d99a6.jpg";